"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var moment_1 = __importDefault(require("moment"));
var exportWarehouseItemsTableToExcel_1 = require("portal/components/Grid/helpers/exportWarehouseItemsTableToExcel");
var hasProjectAndWarehousePermission_1 = require("portal/pages/Projects/hasProjectAndWarehousePermission");
var projectsForWarehouseRole_1 = require("portal/pages/Projects/projectsForWarehouseRole");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var approveReceiveTransferItem_1 = __importDefault(require("../Dialogs/approveReceiveTransferItem"));
var cancelReceiveTransferItem_1 = __importDefault(require("../Dialogs/cancelReceiveTransferItem"));
var ConfirmReceiveTransferDialog_1 = __importDefault(require("../Dialogs/ConfirmReceiveTransferDialog"));
var EditReceiveItem_1 = __importDefault(require("../Dialogs/EditReceiveItem"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var warehouseTransferOperationsSlice_1 = require("src/features/warehouseTransferOperations/warehouseTransferOperationsSlice");
function WarehouseTransferOperationsReceivedTable(props) {
    var _this = this;
    var _a = (0, reduxHooks_1.useAppSelector)(function (state) { return state.warehouseTransferOperations; }), data = _a.receiveTransferData, status = _a.status;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var _b = (0, react_1.useState)(false), modalState = _b[0], setModalState = _b[1];
    var _c = (0, react_1.useState)({}), receiveItemDoc = _c[0], setReceiveItemDoc = _c[1];
    var startOfToday = (0, moment_1.default)();
    var endOfToday = (0, moment_1.default)();
    var _d = (0, react_1.useState)(startOfToday.startOf("day")), startDate = _d[0], setStartDate = _d[1];
    var _e = (0, react_1.useState)(endOfToday.endOf("day")), endDate = _e[0], setEndDate = _e[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var projects = (0, projectsForWarehouseRole_1.projectsForWarehouseRole)(props === null || props === void 0 ? void 0 : props.warehouseId, "viewReceiveWarehouseItems");
    var warehouseId = props.warehouseId, warehouseItems = props.warehouseItems;
    var _f = (0, react_1.useState)(false), approving = _f[0], setApproving = _f[1];
    var _g = (0, react_1.useState)(false), canceling = _g[0], setCanceling = _g[1];
    var _h = (0, react_1.useState)(false), approvingAll = _h[0], setApprovingAll = _h[1];
    (0, react_1.useEffect)(function () {
        dispatch((0, warehouseTransferOperationsSlice_1.fetchReceiveOperationsByDate)({
            warehouseId: warehouseId,
            gt: startDate.toISOString(),
            ls: endDate.toISOString(),
            byField: "createdAt",
        }));
        var unsubscribe = (0, warehouseTransferOperationsSlice_1.subscribeToTransferOperations)(dispatch, warehouseId, "toWarehouseId");
        return function () {
            unsubscribe();
        };
    }, [dispatch, startDate, endDate, warehouseId]);
    var warehouseTransferOperations = (0, react_1.useMemo)(function () {
        return (data !== null && data !== void 0 ? data : [])
            .filter(function (item) { return item.toWarehouseId == warehouseId; })
            .filter(function (d) {
            return d.sourceType != "DN";
        })
            .map(function (x) {
            var data = x;
            return __assign(__assign({}, data), { id: x.id });
        });
    }, [data]);
    var items = warehouseTransferOperations;
    var approveItems = items.filter(function (e) { return e.status == "confirmed"; });
    (0, react_1.useEffect)(function () {
        if (approveItems.length == 0) {
            setApprovingAll(false);
        }
    }, [warehouseTransferOperations, approvingAll]);
    var _j = (0, react_1.useState)(null), warehouseTransferOperation = _j[0], setWarehouseTransferOperation = _j[1];
    var _k = (0, react_1.useState)(null), warehouseTransferOperationId = _k[0], setWarehouseTransferOperationId = _k[1];
    var _l = (0, react_1.useState)(false), showConfirmModal = _l[0], setShowConfirmModal = _l[1];
    var _m = (0, react_1.useState)(false), isApprove = _m[0], setIsApprove = _m[1];
    var confirmReceivePermission = (0, hasProjectAndWarehousePermission_1.hasProjectAndWarehousePermission)(warehouseId, ["confirmReceiveItem"]);
    var approveReceiveItemsPermissin = (0, hasProjectAndWarehousePermission_1.hasProjectAndWarehousePermission)(warehouseId, ["approveReceiveItems"]);
    if (status == "loading") {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var columnsOfReceiveItems = [
        {
            name: "from",
            title: "From",
        },
        {
            name: "dnNumber",
            title: "From DN",
        },
        {
            name: "batchNumber",
            title: t("projects.batchNumber"),
        },
        {
            name: "expiryDate",
            title: t("projects.expiryDate"),
            getCellValue: function (r) {
                return t("common.date", { date: r.expiryDate });
            },
        },
        {
            name: "projectId",
            title: t("projects.projectCode"),
            getCellValue: function (r) { var _a; return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.code; },
        },
        {
            name: "fromWarehouseId",
            title: t("warehouse.fromWarehouse"),
            getCellValue: function (r) { var _a; return (_a = warehousesList_1.globalWarehousesData[r.fromWarehouseId]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "cachedProductName",
            title: t("products.productName"),
        },
        {
            name: "cachedProductUnit",
            title: t("common.unit"),
            getCellValue: function (r) { var _a; return (_a = unitsList_1.globalUnitsData[r.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "cachedProductDescription",
            title: t("products.description"),
        },
        {
            name: "quantity",
            title: t("warehouse.sentQuantity"),
        },
        {
            name: "unitPrice",
            title: t("common.unitPrice"),
            getCellValue: function (row) { var _a; return (_a = row.unitPrice) !== null && _a !== void 0 ? _a : 0; },
        },
        {
            name: "totalPrice",
            title: t("common.totalPrice"),
            getCellValue: function (row) { var _a; return row.quantity * ((_a = row.unitPrice) !== null && _a !== void 0 ? _a : 0); },
        },
        {
            name: "receivedQuantity",
            title: t("common.receivedQuantity"),
        },
        {
            name: "receiverBefore",
            title: "Receiver Before",
        },
        {
            name: "receiverAfter",
            title: "Receiver After",
        },
        {
            name: "stockNumber",
            title: t("warehouse.stockNumber"),
        },
        {
            name: "destinationStockNumber",
            title: t("warehouse.destinationStockNumber"),
        },
        {
            name: "serialNumbers",
            title: t("warehouse.serialNumbers"),
            getCellValue: function (r) {
                var _a;
                return typeof r.serialNumbers == "string"
                    ? r.serialNumbers
                    : (_a = r.serialNumbers) === null || _a === void 0 ? void 0 : _a.join(", ");
            },
        },
        {
            name: "shippingCompany",
            title: t("warehouse.shippingCompany"),
        },
        {
            name: "waybillNumber",
            title: t("warehouse.waybillNumber"),
        },
        {
            name: "stockRequestNumber",
            title: t("warehouse.stockRequestNumber"),
        },
        {
            name: "dnNumber",
            title: t("warehouse.dnNumber"),
        },
        {
            name: "specification",
            title: t("warehouse.specification"),
        },
        {
            name: "notes",
            title: t("common.notes"),
            getCellValue: function (r) { return r.notes; },
        },
        {
            name: "transferredBy",
            title: t("warehouse.transferredBy"),
            getCellValue: function (r) { var _a; return (_a = usersList_1.globalUsersData[r.transferredBy]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "status",
            title: t("common.status"),
        },
        {
            name: "createdAt",
            title: t("warehouse.createdAt"),
            getCellValue: function (r) {
                return t("common.date", { date: r.createdAt });
            },
        },
        {
            name: "SRAttachment",
            title: t("warehouse.SRAttachment"),
            getCellValue: function (r) {
                var url = r.SRAttachment;
                return ((0, jsx_runtime_1.jsx)("div", { children: r.SRAttachment ? ((0, jsx_runtime_1.jsx)("label", __assign({ className: "ant-btn ant-btn-link" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: url, target: "_blank", rel: "noopener noreferrer" }, { children: [(0, jsx_runtime_1.jsx)(icons_1.PaperClipOutlined, {}), t("warehouse.downloadSRAttachment")] })) }))) : ("No attatchment") }));
            },
        },
        {
            name: "roadTracking",
            title: t("warehouse.roadTracking"),
            getCellValue: function (r) {
                var url = r.roadTracking;
                return ((0, jsx_runtime_1.jsx)("div", { children: r.roadTracking ? ((0, jsx_runtime_1.jsx)("label", __assign({ className: "ant-btn ant-btn-link" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: url, target: "_blank", rel: "noopener noreferrer" }, { children: [(0, jsx_runtime_1.jsx)(icons_1.PaperClipOutlined, {}), t("warehouse.downloadWaybillAttachment")] })) }))) : ("No attatchment") }));
            },
        },
        {
            name: "SRNumber",
            title: t("warehouse.SRNumber"),
            getCellValue: function (r) {
                var url = r.SRNumber;
                return ((0, jsx_runtime_1.jsx)("div", { children: r.SRNumber ? ((0, jsx_runtime_1.jsx)("label", __assign({ className: "ant-btn ant-btn-link" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: url, target: "_blank", rel: "noopener noreferrer" }, { children: [(0, jsx_runtime_1.jsx)(icons_1.PaperClipOutlined, {}), t("warehouse.downloadDnFile")] })) }))) : ("No attatchment") }));
            },
        },
        {
            name: "confirmation",
            title: t("warehouse.confirmation"),
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsxs)("div", { children: [r.status === "sent" && confirmReceivePermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: { color: "green" }, onClick: function () {
                                setWarehouseTransferOperation(r);
                                setWarehouseTransferOperationId(r.id);
                                setShowConfirmModal(true);
                                setIsApprove(false);
                            } }, { children: t("warehouse.confirm") }))) : null, r.status === "sent" && confirmReceivePermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: canceling, style: { margin: "5px", color: "red" }, onClick: function () {
                                setCanceling(true);
                                (0, cancelReceiveTransferItem_1.default)(dispatch, r, r.id).then(function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        setCanceling(false);
                                        return [2 /*return*/];
                                    });
                                }); });
                            } }, { children: t("warehouse.cancel") }))) : null, r.status === "confirmed" && approveReceiveItemsPermissin ? ((0, jsx_runtime_1.jsx)(antd_1.Button
                        //    disabled={disabledButtonConfirm}
                        , __assign({ 
                            //    disabled={disabledButtonConfirm}
                            style: { color: "green" }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    setModalState(true);
                                    setReceiveItemDoc(r);
                                    return [2 /*return*/];
                                });
                            }); } }, { children: t("warehouse.edit") }))) : null, r.status === "confirmed" && approveReceiveItemsPermissin ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: { margin: "5px", color: "blue" }, disabled: approving, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setApproving(true);
                                            return [4 /*yield*/, (0, approveReceiveTransferItem_1.default)(dispatch, warehouseId, warehouseItems, r, "approve", r.id)
                                                    .then(function () { return setApproving(false); })
                                                    .catch(function (e) {
                                                    console.log(e);
                                                    antd_1.message.error(e);
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: t("warehouse.approve") }))) : null, r.status === "confirmed" && approveReceiveItemsPermissin ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: canceling, style: { margin: "5px", color: "red" }, onClick: function () {
                                setCanceling(true);
                                (0, cancelReceiveTransferItem_1.default)(dispatch, r, r.id).then(function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        setCanceling(false);
                                        return [2 /*return*/];
                                    });
                                }); });
                            } }, { children: t("warehouse.cancel") }))) : null] }));
            },
        },
    ];
    var approveMany = function () { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setApprovingAll(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Promise.all(approveItems.map(function (item) {
                            return (0, approveReceiveTransferItem_1.default)(dispatch, warehouseId, warehouseItems, item, "approve", item.id).catch(function (e) {
                                console.error(e);
                                antd_1.message.error("Error approving item ".concat(item.stockNumber || item.id));
                            });
                        }))];
                case 2:
                    _a.sent();
                    antd_1.message.success("All items approved!");
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.error("Unexpected error:", e_1);
                    antd_1.message.error("Some approvals failed.");
                    return [3 /*break*/, 5];
                case 4:
                    setApprovingAll(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(antd_1.Spin, __assign({ spinning: canceling || approvingAll || approving, size: "large" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", { children: [t("warehouse.filterStartDate"), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setStartDate(e.startOf("day")); }, value: startDate })] }), (0, jsx_runtime_1.jsxs)("span", { children: [" ", t("warehouse.filterEndDate")] }), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setEndDate(e.endOf("day")); }, value: endDate }), approveReceiveItemsPermissin && approveItems.length > 0 ? ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Are you sure?", okText: "Yes", cancelText: "No", onConfirm: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            approveMany();
                            return [2 /*return*/];
                        });
                    }); } }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Button, __assign({ style: { marginLeft: "1%" } }, { children: ["Approve All ", approveItems.length] })) }))) : null, (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                        margin: "1%",
                    }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var fileName, fields, titles;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    fileName = "Warehouse Received Items Table";
                                    fields = [
                                        "from",
                                        "batchNumber",
                                        "stockNumber",
                                        "destinationStockNumber",
                                        "expiryDate",
                                        "fromWarehouseId",
                                        "projectId",
                                        "cachedProductName",
                                        "cachedProductDescription",
                                        "cachedProductUnit",
                                        "receivedQuantity",
                                        "serialNumbers",
                                        "shippingCompany",
                                        "SRNumber",
                                        "waybillNumber",
                                        "transferredBy",
                                        "createdAt",
                                        "fromWarehouseId",
                                        "status",
                                        "notes",
                                    ];
                                    titles = [
                                        "From",
                                        "Batch Number",
                                        "Stock Number",
                                        "Destination Stock Number",
                                        "Expiry Date",
                                        "From Warehouse",
                                        "Project",
                                        "Product Name",
                                        "Product Description",
                                        "Product Unit",
                                        "Product Quantity",
                                        "Serial Numbers",
                                        "Shipping company",
                                        "SRNumber",
                                        "Waybill Number",
                                        "Transferred by",
                                        "Date",
                                        "From Order",
                                        "status",
                                        "Notes",
                                    ];
                                    return [4 /*yield*/, (0, exportWarehouseItemsTableToExcel_1.exportWarehouseItemsTableToExcel)(data, fields, titles, fileName)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, { children: t("common.exportToExcel") })), (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: items, columns: columnsOfReceiveItems, getRowId: function (r) { return r.id; } }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                        pagination: true,
                        pageSize: 50,
                    }), true) })), showConfirmModal ? ((0, jsx_runtime_1.jsx)(ConfirmReceiveTransferDialog_1.default, { receivedItems: items, modalState: showConfirmModal, setModalState: setShowConfirmModal, warehouseId: warehouseId, warehouseItems: warehouseItems, warehouseTransferOperation: warehouseTransferOperation, warehouseTransferOperationId: warehouseTransferOperationId })) : null, modalState ? ((0, jsx_runtime_1.jsx)(EditReceiveItem_1.default, { modalState: modalState, setModalState: setModalState, warehouseItems: warehouseItems, warehouseId: warehouseId, receiveItemDoc: receiveItemDoc })) : null] }) })));
}
exports.default = WarehouseTransferOperationsReceivedTable;
